// @flow

import { type Feature } from './types';
import { type Trait } from '@tectonics/prs/trait';

export function getSupportedTraits(feature: Feature): ImmutableArray<Trait> {
  return feature.traits || [];
}
